import React, {useEffect} from "react";
import {NavLink} from "react-router-dom";
import {Box, Button, Flex} from "@chakra-ui/react";
import Icon from "../SmartIcon.tsx";
import platform from "platform";
import {NavigationItem} from "../../models/constants/navigationItems.ts";
import {navigationItems} from "../../models/constants/navigationItems.ts";
import KeyCombo from "../KeyCombo.tsx";

interface NavigationProps {
  minimizedState?: boolean;
}

const Navigation: React.FC<NavigationProps> = ({minimizedState}: NavigationProps) => {

  // useEffect(() => {
  //   const isMac: boolean | undefined = platform.os?.family?.includes("OS X");
  //
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     const isCmdOrCtrl: boolean = isMac ? e.metaKey : e.ctrlKey;
  //
  //     if (isCmdOrCtrl && e.key.toLowerCase() === "g") {
  //       e.preventDefault();
  //       alert("Glix AI Search Activated!");
  //     }
  //   };
  //
  //   window.addEventListener("keydown", handleKeyDown);
  //
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  return (
    <Box px={minimizedState ? 2 : 0} w="full">
      {navigationItems.filter((item: NavigationItem) => !item.isComingSoon).map((item: NavigationItem, index: number) =>
        item.url ? (
          <NavLink to={item.url || "#"} key={index} style={{width: "100%"}}>
            {({isActive}) => (
              <Flex
                className={`${isActive ? "text-n-100" : "text-n-300/75"} hover:text-n-100`}
                align="center"
                h="3rem"
                px={minimizedState ? 3 : 5}
                borderRadius="lg"
                fontWeight="semibold"
                transition="all 0.2s ease"
                bgGradient={
                  isActive
                    ? "linear(to-l, #323337, rgba(70,79,111,0.3))"
                    : undefined
                }
                boxShadow={
                  isActive
                    ? "inset 0px 1px 0 rgba(255,255,255,0.05), 0 4px 8px 0 rgba(0,0,0,0.1)"
                    : undefined
                }
              >
                <Icon className={item.color} name={item.icon}/>
                {!minimizedState && <Box className="text-sm ml-3">{item.title}</Box>}
              </Flex>
            )}
          </NavLink>
        ) : (
          <Button
            key={index}
            onClick={item.onClick}
            variant="ghost"
            w="full"
            h="3rem"
            justifyContent="flex-start"
            px={minimizedState ? 3 : 5}
            borderRadius="lg"
            _hover={{bg: "transparent"}}
          >
            <Icon className={item.color} name={item.icon}/>

            {!minimizedState && <Box className="text-sm ml-3 text-n-300/75 hover:text-n-100">{item.title}</Box>}
            {item.title === "Glix AI" && !minimizedState && (
              <KeyCombo value={platform.os?.family?.includes("OS X") ? "⌘ G" : "Ctrl G"}/>
            )}
          </Button>
        )
      )}
    </Box>
  );
};

export default Navigation;